App.Models.SalesReport = BackboneEx.Model.Silent.extend({
  filters: {},

  url: function () {
    var base = '/venue/' + App.getVenueId() + '/reports/sales.json?' + this.getUrlFilterString();
    return App.Api.wsUrl(base);
  },
});
